import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import React from "react";
import { TEMPLATE_ID_DEFAULT } from "../../config/templates";

const DefaultTemplate = props => {

	const { children, isSuppressingNav } = props;

	return (
		<React.Fragment>
			<Header isSuppressingNav={isSuppressingNav} />
			<main data-template-id={TEMPLATE_ID_DEFAULT} id="main">
				{children}
			</main>
			<Footer />
		</React.Fragment>
	);
};

export default DefaultTemplate;